import { styled } from "styled-components";
import { Link } from "react-router-dom";
import { useTestimonials } from "../hooks/useTestimonials";
import TestimonialSection from "../components/common/TestimonialSection";
import PartnersContainer from "../components/common/PartnersContainer";
import { FAQAccordion } from "../components/FAQ";
import { faqData } from "../data/faqData";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 60px 60px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1023px) {
    padding: 30px 40px;
  }

  @media (max-width: 767px) {
    padding: 20px;
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  width: 100%;
  max-width: 1608px;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  flex: 1;
  min-width: 0;

  @media (max-width: 1023px) {
    gap: 30px;
  }
`;

const PageTitle = styled.h1`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 32px;
    line-height: 40px;
  }
`;

const IntroText = styled.p`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.blue500};
  margin: 0;

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Help = () => {
  const { data: testimonials = [] } = useTestimonials();

  return (
    <PageWrapper>
      <ContentArea>
        <ContentRow>
          <LeftContent>
            <PageTitle>Nápověda</PageTitle>

            <IntroText>
              Máš dotaz? Níže najdeš odpovědi na nejčastější otázky.
              Pokud nenajdeš, co hledáš, neváhej kontaktovat naši{" "}
              <Link to="/kontakt">podporu</Link>.
            </IntroText>

            <FAQAccordion categories={faqData} />
          </LeftContent>
        </ContentRow>
      </ContentArea>

      <TestimonialSection testimonials={testimonials} />
      <PartnersContainer />
    </PageWrapper>
  );
};

export default Help;
